import HtmlText from 'shared/components/HtmlText/HtmlText';
import styled from 'styled-components';

/*
 * RES-1367: no margins of its own -- same correction as receipt-user-response/styles.ts.
 *
 * The `-18px` here was tuned against CollapsableBlock's 28px lead-in, the only one this block had
 * when it was written. Under `compact` (16px) and `section` (16px) it overshoots, and the policy
 * climbed onto the heading above it; the 28px below was dead space in every variant. The block's
 * own `Content` is a flex column with a gap, so the spacing is already somebody's job.
 */
export const Text = styled(HtmlText)`
  font: 400 16px/20px ${({ theme }) => theme.fonts.join()};
  color: ${({ theme }) => theme.colors.fontColor};
`;
